var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 42"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 42_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.4114 0C9.72312 0 9.06556 0.245175 8.57833 0.684375L8.00632 1.2H1.35019C1.17378 1.19775 0.998643 1.22713 0.834945 1.28643C0.671246 1.34572 0.522253 1.43375 0.396626 1.54541C0.270999 1.65706 0.171242 1.79011 0.103152 1.93682C0.0350632 2.08353 0 2.24097 0 2.4C0 2.55903 0.0350632 2.71647 0.103152 2.86318C0.171242 3.00989 0.270999 3.14294 0.396626 3.25459C0.522253 3.36625 0.671246 3.45428 0.834945 3.51357C0.998643 3.57287 1.17378 3.60225 1.35019 3.6H22.6498C22.8262 3.60225 23.0014 3.57287 23.1651 3.51357C23.3288 3.45428 23.4777 3.36625 23.6034 3.25459C23.729 3.14294 23.8288 3.00989 23.8968 2.86318C23.9649 2.71647 24 2.55903 24 2.4C24 2.24097 23.9649 2.08353 23.8968 1.93682C23.8288 1.79011 23.729 1.65706 23.6034 1.54541C23.4777 1.43375 23.3288 1.34572 23.1651 1.28643C23.0014 1.22713 22.8262 1.19775 22.6498 1.2H15.9937L15.4217 0.684375C14.9358 0.245175 14.2769 0 13.5886 0H10.4114ZM1.8364 6L3.86964 21.9164C4.04536 23.1044 5.18013 24 6.50869 24H17.4887C18.8173 24 19.9533 23.1058 20.1304 21.907L22.1636 6H1.8364Z",
    fill: "#3B457B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.3fa7028e18e0dc8062c97d12a418db8b.svg";
export { ForwardRef as ReactComponent };